import { useContext, useEffect } from "react"
import { Box, Button, Grid, InputBase } from "@mui/material"
import { AddRoundIcon, EditProfile, SearchIcons } from "../../../../../core/global/Icons"
import { useHistory } from "react-router-dom"
import { PrimaryToolTip } from "../../../../../core/global/ToolTip"
import { ToolContext } from "../../../../../core/context/ToolContext"
import { ListLoader } from "../../loader/ListLoader"
import { NoDataFound } from "../../../empty/Index"
import { CstmSnackBar } from "../../../../../core/global/forms/CstmSnackBar"
import { CategoryRead } from "../../../global/API"

export const List = ({loader, setLoader}) => {
    const nav = useHistory()
    const { tool_state, setup_state } = useContext(ToolContext)
    const { __SESSION } = tool_state
    const { categoryList, categorySearchList, searchInput, listLoader } = setup_state

    const redirectionHandler = (type, value) => {
        setLoader({...loader, snackbar:false, msg:''})
        nav.push(`/setup/category/${type === 'create' ? type : window.btoa(JSON.stringify(value))}`)
    }

    const __init = async() => {
        listLoader.set((prev) => ({...prev.data, isloading:true}))
        let res = await CategoryRead(__SESSION.data.uaccess[0].company_id, 'category', 'all')
        if (res) {
            categoryList.set(res)
            listLoader.set((prev) => ({...prev.data, isloading:false}))
        }
    }

    useEffect(() => {
        __init()
        // eslint-disable-next-line
    }, [])

    const searchHandler = () => {
        let sort_data = categoryList.data.filter(item => 
            item.series_num.toLowerCase().includes(searchInput.data.toLowerCase()) ||
            item.name.toLowerCase().includes(searchInput.data.toLowerCase())
        )
        categorySearchList.set(sort_data)
        listLoader.set((prev) => ({...prev.data, isloading:false}))
    }

    useEffect(() => {
        if (!listLoader.data.isloading) {
            listLoader.set((prev) => ({...prev.data, isloading:true}))
        }
        const searchFcn = setTimeout(() => {
            if (searchInput.data === '') {
                listLoader.set((prev) => ({...prev.data, isloading:false}))
            }else{
                searchHandler()
            }
        }, 500);
        return () => clearTimeout(searchFcn)
        //eslint-disable-next-line
    }, [searchInput.data])
    
    return (
        <Box height="100%" width="100%" bgcolor="#FFFFFF" borderRadius="12px" display="flex" flexDirection="column" p={3}>
            <Box minHeight="120px" display="flex" flexDirection="column" gap={3}>
                <Box width="100%" display="flex" alignItems="center" justifyContent="space-between">
                    <InputBase
                        onInput={(e)=> searchInput.set(e.target.value)}
                        placeholder="Search"
                        inputProps={{ 'aria-label': 'search' }} endAdornment={ <Box pr={1} pt={1}><SearchIcons /></Box> }
                        sx={{backgroundColor: "#FFFFFF", border: "#D9EBE8 solid 2px", borderRadius: '10px', padding: '5px 5px 5px 20px', width: '291px', height: '49px'}}
                    />
                    <Box onClick={()=>redirectionHandler('create')} component={Button} disableFocusRipple={true} minHeight="50px" borderRadius={3} display="flex" alignItems="center" justifyContent="center" bgcolor="primary.main" color="#fff" sx={{border:"2px solid #EBEBEB", ':hover':{bgcolor:'primary.main', color:'#FFFFFF'}}} startIcon={<AddRoundIcon/>} px={3}>
                        <Box fontSize={16} fontWeight={400} lineHeight="19px">Category</Box>
                    </Box>
                    
                </Box>
                <Grid container direction="row" sx={{px:2}}>
                    <Grid item xs={4}>Category Number</Grid>
                    <Grid item xs={4}>Category Name</Grid>
                    <Grid item xs={2} textAlign="center">Status</Grid>
                    <Grid item xs={2} textAlign="center">Action</Grid>
                </Grid>
            </Box>

            <Box height="100%" width="100%" className="overflowY" display="flex" flexDirection="column" gap="12px">
                {listLoader.data.isloading && <ListLoader/>}
                {(!listLoader.data.isloading && ( searchInput.data === '' ? categoryList.data.length === 0 : categorySearchList.data.length === 0 ) ) && <NoDataFound/>}
                {!listLoader.data.isloading && ( searchInput.data === '' ? categoryList.data: categorySearchList.data ).map((v,k) => (
                    <Grid key={k} container direction="row" sx={{p:2, border:'1px solid #EBEBEB', borderRadius:'10px'}}>
                        <Grid item xs={4}>{v.series_num}</Grid>
                        <Grid item xs={4}>{v.name}</Grid>
                        <Grid item xs={2} textAlign="center">{v.active === 1 ?"Active":"Inactive"}</Grid>
                        <Grid item xs={2} textAlign="center">
                            <PrimaryToolTip onClick={()=>redirectionHandler('edit', v)} title="Update" arrow sx={{margin: '0 14px 0 14px'}} placement="top">
                                <Box fontWeight={500} className="c-pointer">
                                    <EditProfile fill={'none'} stroke={'#292d32'}/>
                                </Box>
                            </PrimaryToolTip>
                        </Grid>
                    </Grid>
                ))}
            </Box>
            {loader.snackbar && (
                <CstmSnackBar value={loader} setter={setLoader} msg={loader.msg} type='success' /> 
            )}
        </Box>
    )
}